import { render, staticRenderFns } from "./SegmentationLimiter.vue?vue&type=template&id=23b4c5e3"
import script from "./SegmentationLimiter.vue?vue&type=script&lang=js"
export * from "./SegmentationLimiter.vue?vue&type=script&lang=js"
import style0 from "./SegmentationLimiter.vue?vue&type=style&index=0&id=23b4c5e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports